import moment from "moment";
import React, { Component } from "react";
import "react-block-ui/style.css";
import Datetime from "react-datetime";
import { Link } from "react-router-dom";
import LoadingIndicator from "../Components/LoadingIndicator/LoadingIndicator";
import Pagination from "../Shared/pagination";
import ReportsService from "../utils/ReportsService";

const STAT_WIDTH = 210;
const STAT_HEIGHT = 112;

function priorNight() {
  return moment().subtract(1, "days").format("DD MMM YYYY");
}

const Stat = ({ value, label, subLabel }) => (
  <div
    className="status-card"
    style={{ width: STAT_WIDTH, height: STAT_HEIGHT, flex: "0 0 auto" }}
  >
    <div
      className="panel status panel-info"
      style={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <div
        className="panel-heading"
        style={{
          flex: "0 0 56px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <h1 className="panel-title text-center" style={{ margin: 0 }}>
          {value}
        </h1>
      </div>
      <div
        className="panel-body text-center"
        style={{
          flex: "1 1 auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          overflow: "hidden"
        }}
      >
        <strong style={{ fontSize: 14, lineHeight: 1.2 }}>{label}</strong>
        {subLabel && (
          <span style={{ fontSize: 12, color: "#888", marginTop: 2 }}>{subLabel}</span>
        )}
      </div>
    </div>
  </div>
);

const PercentBadge = ({ value }) => (
  <span
    style={{
      display: "inline-block",
      background: "#e3f0fb",
      color: "#2f6fb0",
      fontWeight: 600,
      padding: "3px 12px",
      borderRadius: 4
    }}
  >
    {value}%
  </span>
);

const RepBreakdownTable = ({ rows }) => (
  <table className="table table-bordered">
    <thead>
      <tr>
        <th>Sales Rep</th>
        <th>Single Parent (Number)</th>
        <th>Single Parent (%)</th>
        <th>Sales</th>
        <th>Single Parent Conversion (%)</th>
      </tr>
    </thead>
    <tbody>
      {rows.map(row => (
        <tr key={row.email}>
          <td>{row.name}</td>
          <td>{row.single_parent_count}</td>
          <td>
            <PercentBadge value={row.single_parent_percent} />
          </td>
          <td>{row.sales_count}</td>
          <td>
            <PercentBadge value={row.conversion_percent} />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

const DetailTable = props => {
  const { data } = props;

  const rows = data.map((value, index) => (
    <tr key={index}>
      <td>
        <Link to={`/m1/deals/${value["id"]}`}>Deal #{value["id"]}</Link>
      </td>
      <td>
        {moment(value["tcs_at"])
          .tz("Australia/Sydney")
          .format("dddd Do MMM, h:mma")}
      </td>
      <td>{value["notes_single_parent_attending"]}</td>
    </tr>
  ));
  return (
    <table className="table table-bordered">
      <thead>
        <tr>
          <th>Id</th>
          <th>TCS At</th>
          <th>Single Parent Attending Reason</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
};

class ReportingSingleParentAttending extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        start_date: priorNight(),
        end_date: priorNight()
      },
      data: null,
      currentPage: 1,
      totalPages: 1,
      per: 50,
      loadingInProgress: false
    };
  }

  componentDidMount() {
    this.fetchItems();
  }

  fetchItems = () => {
    this.setState({ loadingInProgress: true });
    ReportsService.singleParentAttending({
      page: this.state.currentPage,
      per: this.state.per,
      filter: {
        start_date: this.state.filter.start_date,
        end_date: this.state.filter.end_date
      }
    }).then(data => {
      this.setState({
        loadingInProgress: false,
        data: data,
        totalPages: data.total_pages || 1
      });
    });
  };

  onPageChange = currentPage => {
    this.setState({ currentPage: currentPage }, this.fetchItems);
  };

  onDateChange = (field, value) => {
    const filter = {
      ...this.state.filter,
      [field]: value.format("DD MMM YYYY")
    };
    this.setState({ filter, currentPage: 1 }, this.fetchItems);
  };

  render() {
    const { data, filter, loadingInProgress, totalPages, currentPage } = this.state;

    return (
      <div>
        <h4 style={{ marginTop: 0 }}>Date range</h4>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 10,
            marginBottom: 20
          }}
        >
          <Datetime
            inputProps={{ className: "form-control input-sm", style: { width: 140 } }}
            onChange={v => this.onDateChange("start_date", v)}
            value={filter.start_date}
            closeOnSelect={true}
            dateFormat="DD MMM YYYY"
            timeFormat={false}
          />
          <span>-</span>
          <Datetime
            inputProps={{ className: "form-control input-sm", style: { width: 140 } }}
            onChange={v => this.onDateChange("end_date", v)}
            value={filter.end_date}
            closeOnSelect={true}
            dateFormat="DD MMM YYYY"
            timeFormat={false}
          />
        </div>

        <LoadingIndicator loadingInProgress={loadingInProgress}>
          {data && (
            <div>
              <h4>Confirmed Bookings - Single Parent Analysis</h4>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 24, marginBottom: 30 }}>
                <Stat value={data.total_confirmed} label="Total Confirmed" />
                <Stat
                  value={`${data.single_parent_count} (${data.single_parent_percent}%)`}
                  label="Single Parent Attending"
                  subLabel="of total confirmed"
                />
                {data.by_cs_rep
                  .filter(rep => rep.single_parent_count > 0)
                  .map(rep => (
                    <Stat
                      key={rep.email}
                      value={`${rep.single_parent_count} (${rep.single_parent_percent}%)`}
                      label={`Single Parent ${rep.name.split(" ")[0]}`}
                      subLabel="of Single Parent Attending"
                    />
                  ))}
                <Stat
                  value={`${data.conversion_count} (${data.conversion_percent}%)`}
                  label="Single Parent Conversion"
                  subLabel="of Single Parent Attending"
                />
              </div>

              <h4>Single Parent Bookings by Sales Rep</h4>
              <RepBreakdownTable rows={data.by_sales_rep} />
              <p style={{ color: "#888" }}>
                Single Parent (%) is Single Parent appointments ÷ that rep's Presented total. Single Parent
                Conversion (%) is Sales ÷ that rep's Single Parent appointments.
              </p>

              <h4 style={{ marginTop: 30 }}>Single Parent Attending Reporting</h4>
              {totalPages > 1 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onChange={this.onPageChange}
                />
              )}
              <DetailTable data={data.results} />
            </div>
          )}
        </LoadingIndicator>
      </div>
    );
  }
}
export default ReportingSingleParentAttending;
